import './App.css';
import React from 'react';
import Po from "./po";
import NotFound from "./notFound";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

function App() {

  return (
    <>
      <div className="d-flex justify-content-center w-100" style={{ minHeight: "100%" }}>
        <Router>
          <Routes>
            <Route exact path='/po/:poId' element={<Po isTest={false} version={1} />} />
            <Route exact path='/po/preview/:poId/' element={<Po isTest={true} version={1} />} />
            <Route exact path='/po/v2/:poId' element={<Po isTest={false} version={2} />} />
            <Route exact path='/po/v2/preview/:poId/' element={<Po isTest={true} version={2} />} />
            <Route exact path='/po/v2/final-view/:poId' element={<Po isTest={false} version={2} finalView={true} />} />
            <Route exact path='/po/v2/final-view/preview/:poId/' element={<Po isTest={true} version={2} finalView={true} />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </Router>
      </div>
    </>
  );
}

export default App;
